import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MsalService } from '@azure/msal-angular';
import { UserSettingModel } from 'src/app/Modules/settings/models/informate';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { MatAccordion } from '@angular/material/expansion';
import { ManagementApiService } from 'src/app/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomToastService } from 'src/app/services/custom-toast.service';

export interface ResultObjModel {
    UserId: string;
    SettingId: string;
    UserSettingId: string;
    SettingValueId: string;
}
interface setPreferences {
    groupName: string;
    name: string;
    email: UserSettingModel;
    notification: UserSettingModel;
}
export interface ResultObjModel {
    UserId: string;
    SettingId: string;
    UserSettingId: string;
    SettingValueId: string;
}
@Component({
    selector: 'app-user-email-notification-details',
    templateUrl: './user-email-notification-details.component.html',
    styleUrls: ['./user-email-notification-details.component.scss'],
})
export class UserEmailNotificationDetailsComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @ViewChild(MatAccordion) accordion: MatAccordion;
    @Output() result: EventEmitter<ResultObjModel[]> = new EventEmitter();

    datasourceArray: any = [];
    datasourceArrayDisplay: any = [[], [], [], [], []];
    resultObj: ResultObjModel[] = [];
    isEditable: boolean;
    isCheck: boolean;
    isScheduledisable: boolean;
    isProjectManagement: boolean;
    isRulesActions: boolean;
    lincenseExpire: boolean;
    disable: boolean;
    item: setPreferences[];
    getEmailandNotifications: any;
    profileSettingAreaId: string;
    _dataSource: UserSettingModel[];
    isIdms: boolean = false;

    constructor(
        private authService: MsalService,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService,
        private formBuilder: UntypedFormBuilder,
        private customToastServiceService: CustomToastService
    ) {}

    async ngOnInit(): Promise<void> {
        let instanceType = JSON.parse(localStorage.getItem('selectedInstanceDetails'));
        if (instanceType) {
            let index = instanceType?.instanceType?.index ? instanceType?.instanceType?.index : instanceType[0]?.instanceType?.index;
            this.isIdms = (await this.user_utility.checkUserPermissionDataAndRoute('view-idms-settings', userActions.View)) && index != 1;
        }
        this.globalEmittersService.refreshEmailAndNoti.subscribe((res) => {
            if (res === true) {
                this.accordion.closeAll();
                this.resultObj = [];
            }
        });

        this.getEmailAndNoti();
        this.isEditable = await this.user_utility.checkUserPermissionDataAndRoute('profile-email-notification-setting', userActions.Edit);

        this.globalEmittersService.saveEmailNotiDetails.subscribe((res) => {
            if (res) {
                this.saveEnailNotification();
            }
        });
    }

    initEmailNoti() {
        this.getEmailandNotifications?.forEach((res) => {
            if (this.datasourceArray.length) {
                const f1 = this.datasourceArray.find((t) => t.name === res.setting.name);
                if (f1) {
                    if (f1.email) {
                        f1.notification = { ...res, checked: this.getCheckedState(res) };
                    } else {
                        f1.email = { ...res, checked: this.getCheckedState(res) };
                    }
                } else {
                    this.datasourceArray.push({
                        name: res.setting.name,
                        email: res.setting.settingSubSection.name.toLowerCase() === 'emails' ? { ...res, checked: this.getCheckedState(res) } : undefined,
                        notification:
                            res.setting.settingSubSection.name.toLowerCase() == 'notifications' ? { ...res, checked: this.getCheckedState(res) } : undefined,
                    });
                }
            } else {
                this.datasourceArray.push({
                    name: res.setting.name,
                    email: res.setting.settingSubSection.name.toLowerCase() === 'emails' ? { ...res, checked: this.getCheckedState(res) } : undefined,
                    notification:
                        res.setting.settingSubSection.name.toLowerCase() == 'notifications' ? { ...res, checked: this.getCheckedState(res) } : undefined,
                });
            }
        });
        //check for menus permission
        this.datasourceArray.forEach((x) => {
            let resp = [];
            //resp = x.name.split(' ');
            if (x.name.includes('days') || x.name.includes('day')) {
                this.datasourceArrayDisplay[4].push({
                    groupName: 'lincense Expire',
                    ...x,
                });
            } else if (x.name.includes('action')) {
                if (this.isIdms)
                    this.datasourceArrayDisplay[3].push({
                        groupName: 'Rules & Actions',
                        ...x,
                    });
            } else if (x.name.includes('batch') || x.name.includes('upload')) {
                if (this.isIdms)
                    this.datasourceArrayDisplay[2].push({
                        groupName: 'Batch Calculation & Uploads',
                        ...x,
                    });
            } else if (x.name.includes('added')) {
                if (this.isIdms)
                    this.datasourceArrayDisplay[1].push({
                        groupName: 'Project Management',
                        ...x,
                    });
            } else if (x.name.includes('scheduled')) {
                this.datasourceArrayDisplay[0].push({
                    groupName: 'Scheduled Maintenance',
                    ...x,
                });
            }
        });
    }

    checkBoxChange(event: MatCheckboxChange, groupName: string, val: UserSettingModel, arraytoDisplay: any[]) {
        let checkType = -1;
        let selectedValueId;
        if (val.setting.settingSubSection.name.toLocaleLowerCase() == 'emails') {
            checkType = 1;
            arraytoDisplay.forEach((x, i) => {
                x.forEach((y) => {
                    if (y.email && groupName == y.groupName && val.setting.settingId == y.email.setting.settingId) {
                        y.email.checked = event.checked;
                    }
                });
            });
        } else {
            checkType = 2; //selected checkbox belong to Notification
            arraytoDisplay.forEach((x, i) => {
                x.forEach((y) => {
                    if (y.notification && groupName == y.groupName && val.setting.settingId == y.notification.setting.settingId) {
                        y.notification.checked = event.checked;
                    }
                });
            });
        }

        let res = val.setting.settingValues;
        selectedValueId = res.find((r) => String(event.checked).toLowerCase() == r.value.toLowerCase()).settingValueId;

        switch (checkType) {
            case 1:
                this.form.get('emailNotification').get(`Emails_${val.setting.name}`).setValue(selectedValueId);
                this.form.get('emailNotification').get(`Emails_${val.setting.name}`).markAsDirty();
                this.form.get('emailNotification').get(`Emails_${val.setting.name}`).markAllAsTouched();

                break;
            case 2:
                this.form.get('emailNotification').get(`Notifications_${val.setting.name}`).setValue(selectedValueId);
                this.form.get('emailNotification').get(`Notifications_${val.setting.name}`).markAsDirty();
                this.form.get('emailNotification').get(`Notifications_${val.setting.name}`).markAllAsTouched();
                break;
        }

        let obj: any = {};
        obj.UserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        obj.SettingId = val.setting.settingId;
        obj.UserSettingId = val.userSettingId;
        obj.SettingValueId = selectedValueId;

        this.removeCopyObj(val.setting.settingId);
        this.resultObj.push(obj);
        this.result.emit(this.resultObj);
    }

    //method for getting state of the checkbox
    getCheckedState(e) {
        let res = this.getEmailandNotifications.find((resp) => resp.setting.settingId === e.setting.settingId)?.settingValue.value.toLocaleLowerCase() ?? null;
        return res === 'true' ? true : false;
    }

    // Select All CheckBox Change
    SelectEmailcheckBoxChange($event: MatCheckboxChange, array: setPreferences[]) {
        array.forEach((a) => {
            if (a.email) {
                this.checkBoxChange($event, a.groupName, a.email, this.datasourceArrayDisplay);
                a.email.checked = $event.checked;
            }
        });
        this.getCheckSelectAllStatus(array);
    }

    // Select All CheckBox Change
    SelectNoticheckBoxChange($event: MatCheckboxChange, array: setPreferences[]) {
        array.forEach((a) => {
            this.checkBoxChange($event, a.groupName, a.notification, this.datasourceArrayDisplay);
            a.notification.checked = $event.checked;
        });
        this.getCheckSelectAllStatusNoti(array);
    }

    //checking strtaus of select all
    getCheckSelectAllStatus(array: setPreferences[]) {
        if (array?.length > 0) {
            if (array.every((a) => a?.email?.checked == true || a?.email == undefined) == true) {
                return true;
            } else {
                return false;
            }
        }
    }

    getCheckSelectAllStatusNoti(array: setPreferences[]) {
        if (array.every((a) => a.notification.checked == true) == true) {
            return true;
        } else {
            return false;
        }
    }

    someComplete(array: setPreferences[], checkstring: string) {
        let result = 0;
        let _ArrEmail: setPreferences[];
        if (checkstring == 'email') {
            _ArrEmail = array.filter((acc) => acc?.email != undefined);
            result = _ArrEmail.filter((acc) => acc?.email?.checked == true).length;
        } else {
            _ArrEmail = array;
            result = array.filter((acc) => acc.notification.checked == true).length;
        }
        if (_ArrEmail.length && result > 0 && _ArrEmail.length != result) {
            return true;
        }
    }

    //removing  copy objects
    removeCopyObj(settingId: string) {
        if (this.resultObj.length >= 1) {
            for (let i = 0; i < this.resultObj.length; i++) {
                if (this.resultObj[i].SettingId == settingId) {
                    this.resultObj.splice(i, 1);
                }
            }
        }
    }

    getEmailAndNoti() {
        this.ngxUiLoaderService.start();
        this.managementApiService.getSettingProfileAreaId('userprofile').subscribe(
            (res) => {
                if (res.success === true) {
                    this.profileSettingAreaId = res.response.settingAreaId;
                    if (this.profileSettingAreaId) {
                        this.managementApiService.getSettingbySettinfAreaId(this.profileSettingAreaId).subscribe((resp) => {
                            if (resp.success === true) {
                                this.getEmailandNotifications = resp.response;
                                // this.EmailData.emit(this.getEmailandNotifications);
                                this.addControls(resp.response);
                                this.initEmailNoti();
                                this.ngxUiLoaderService.stop();
                            } else {
                                this.ngxUiLoaderService.stop();
                            }
                        });
                    }
                } else {
                    this.ngxUiLoaderService.stop();
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    addControls(resp) {
        // this.form.get ("emailNotification", new FormGroup({}));
        resp.forEach((res, i) => {
            let EmailNotiForm = this.form.get('emailNotification') as UntypedFormGroup;
            EmailNotiForm.addControl(`${res.setting.settingSubSection.name}_${res.setting.name}`, this.formBuilder.control(this.getFormStateValue(res)));
        });
    }

    getFormStateValue(userSetting: UserSettingModel) {
        if (userSetting.value) {
            return userSetting.value;
        }

        if (userSetting.settingValue) {
            return userSetting.settingValue.settingValueId;
        }
        return null;
    }

    saveEnailNotification() {
        //Doing Api call for  email and notifications
        if (this.resultObj.length) {
            this.ngxUiLoaderService.start();
            this.managementApiService.updateUserSettings(this.resultObj).subscribe(
                (res) => {
                    if (res.success === true) {
                        this.ngxUiLoaderService.stop();
                        this.resultObj = [];
                        this.globalEmittersService.refreshEmailAndNoti.next(true);
                        this.form.get('emailNotification').markAsPristine();
                        this.customToastServiceService.successToast('UserSettings updated successfully', 'Success');
                    } else {
                        this.resultObj = [];
                        this.ngxUiLoaderService.stop();
                        this.customToastServiceService.errorToast(res.message);
                        this.globalEmittersService.refreshEmailAndNoti.next(true);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                    this.globalEmittersService.refreshEmailAndNoti.next(true);
                    //here toastr will be added
                }
            );
        }
    }
    itemList(array: any) {
        return array.sort((a, b) => a.name.localeCompare(b.name));
    }
    datasourceArrayDisplayFiltered() {
        return this.datasourceArrayDisplay.filter((m) => m[0]?.groupName);
    }
}
